import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { InventoryTypeService } from '../proxy/planning/controllers/inventory-type.service';

FieldBuilder.setNamespace('Planning');

export const INVENTORYSUBTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InventorySubType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.InventorySubType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder.foreignKey(
    'inventoryTypeId',
    'Entity.InventoryType',
    InventoryTypeService
  )
    .required()
    .displayFromNested('inventoryType.name')
    .sortBy('inventoryType.name')
    .build(),
];

export const INVENTORYSUBTYPE_CONFIG = {
  entityName: 'InventorySubType',
  localizationKey: 'Planning::Entity.InventorySubType',
  fields: INVENTORYSUBTYPE_FIELDS,
  permission: 'PlanningInventory.InventorySubTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,
};
